import React from 'react'
import { Updater, any, async, fromJSX, nothing } from 'widgets-for-react'
import { getCookie } from '../../utils/cookies'
import { JqueryState } from '../jquery/jqueryState'
import { FooterLayout } from './footerLayout'
import { FooterState, FooterData, footerStateUpdaters } from './footerState'

export const footerWidget = (
  showCookiebar: () => void,
  showPrefooter: boolean
) => (state: FooterState, jquery: JqueryState) => {
  const footerDataState = state.footerDataState;
  return any<Updater<FooterState>>([
    async<FooterData>(state.footerDataState).map(
      footerStateUpdaters.updateFooterDataState
    ),
    footerDataState.kind === 'loaded'
      ? fromJSX(setState => (
      <FooterLayout
        items={footerDataState.value}
        showCookiebar={showCookiebar}
        trackingCookiesAccepted={getCookie('tracking-cookies') == 'yes'}
        showPrefooter={showPrefooter}
        mailPlusForm={state.mailPlusForm}
        jquery={jquery}
        setMailPlusForm={m => setState(r => ({
          ...r,
          mailPlusForm: m
        }))}
      />
    ))
    : nothing()
  ])
}
